import { render, staticRenderFns } from "./newWork.vue?vue&type=template&id=0356c9b8&scoped=true"
import script from "./newWork.vue?vue&type=script&lang=js"
export * from "./newWork.vue?vue&type=script&lang=js"
import style0 from "./newWork.vue?vue&type=style&index=0&id=0356c9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356c9b8",
  null
  
)

export default component.exports